<template>
  <div id="target-area" class="target-vue">
    <RouterView v-slot="{ Component, route }">
      <component :is="Component" :key="route.meta.remountOnNavigate ? route.fullPath : undefined" />
    </RouterView>
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
</script>
